export default function Pricing() {
  const plans = [
    {
      name: 'スタートセット',
      price: '9,900',
      popular: false,
      features: [
        '電話診療 1回',
        'ホワイトニングシート 4回分',
        '送料無料',
      ]
    },
    {
      name: 'スタンダードセット',
      price: '13,500',
      popular: true,
      features: [
        '電話診療 1回',
        'ホワイトニングシート 6回分',
        '送料無料',
      ]
    },
    {
      name: 'プレミヤムセット',
      price: '16,500',
      popular: false,
      features: [
        '電話診療 1回',
        'ホワイトニングシート 8回分',
        '送料無料',
      ]
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">料金プラン</h2>
          <p className="text-lg text-gray-600">診療代込みの安心価格</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-start">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl p-8 relative ${
                plan.popular 
                  ? 'border-2 border-[#4A90E2] shadow-xl md:-translate-y-4' 
                  : 'border-2 border-gray-200 shadow-md'
              } hover:shadow-2xl transition-all duration-300`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-6 py-2 bg-[#4A90E2] text-white text-sm font-bold rounded-full shadow-lg transform -rotate-2">
                  人気No.1
                </div>
              )}
              
              <div className="text-center mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-6">{plan.name}</h3>
                
                <div className="mb-4">
                  <span className="text-5xl font-bold text-gray-900">{plan.price}</span>
                  <span className="text-lg text-gray-500 ml-1">円</span>
                </div>
                
                <p className="text-sm text-gray-500">（税込）</p>
                <p className="text-xs text-gray-400 mt-2">診療代＋シート代込み</p>
              </div>

              <ul className="space-y-4">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-5 h-5 bg-[#4A90E2] rounded-full flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-sm text-gray-700 leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}